import $ from 'jquery';

import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/background-gradient-color.ejs';
import themeService from 'ThemeService.js';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';
import { pickerCfg } from 'pickerCfg.js';

import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import undoService from 'UndoService';

class StyleBackgroundGradientColor extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.showGradient = true;

        if (this.model.get('factoryKey') === 'control_checkbox' ||
            this.model.get('factoryKey') === 'control_radio_button' ||
            this.model.get('factoryKey') === 'control_mask_text_input') {
            this.model.set('showNormalLabel', false,{silent:true});
        } else {
            this.model.set('showNormalLabel', true,{silent:true});
        }

        if (this.model.get('factoryKey') === 'control_checkbox' ||
            this.model.get('factoryKey') === 'control_radio_button') {
            this.showGradient = false;
        }
        
        this.model.set('showGradient', this.showGradient, {silent:true});
         
        this.events = {
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'keydown #advancedBgGradientColor' : 'keyAction',
            'change input[type=checkbox]': 'updateTransparentBackground'
        };

        return this;
    }

    keyAction(ev) {
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
        }
    }


    render() {
        super.render();

        let props = this.model.toJSON();

        props.backgroundColor = themeService.resolve(props.backgroundColor);
       
        props.buttonBgColor = props.buttonBgColor ? themeService.resolve(props.buttonBgColor) : '#FFFFFF';
        props.buttonBgGradientColor = props.buttonBgGradientColor ? themeService.resolve(props.buttonBgGradientColor) : '#FFFFFF';
        props.advancedBgGradientColor = props.advancedBgGradientColor ? themeService.resolve(props.advancedBgGradientColor) : '#FFFFFF';
        props.transparentBackground = themeService.resolve(props.transparentBackground);

       

        this.$el.html(this.template(props));

        if (this.model.get('factoryKey') === 'control_checkbox' ||
        this.model.get('factoryKey') === 'control_radio_button') {
         
            if(util.isTrue(props.transparentBackground)){
                $(`input[name=backgroundColor]`).prop('disabled',true);
            }else{
                $(`input[name=backgroundColor]`).prop('disabled',false);
            }
    }

      //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        let color = this.resolveColor(propVal);
        
        // Update model
        if (util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent(propName,propVal,model,this.render.bind(this),'GroupPropertyChange');

        }else{
            this.model.set(propName, propVal);
        }

        if (this.isThemeProperty(oldValue)){
            themeService.deattachTheme(this);
        }

        // Update text input
        $('#' + propName).val(color);

        if (this.model.get('factoryKey') === "page_instance"
            || this.model.get('factoryKey') === "layout_page"
            || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
        }

        if(this.model.get('factoryKey') === 'control_captcha'){
            this.model.set('captchaImage', imageUtil.getCaptchaPresentationServerURLByView(this));
        }

        undoService.add({
            undo: () =>{
                // Update model
                // PF-4777 Handling for radio and checkbox groups.
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldValue,this.model,this.render.bind(this),'CheckboxThemeChange');
                }else{
                    this.model.set(propName, oldValue);
                }

                let oldColor = this.resolveColor(oldValue);
                // Update text input
                $('#' + propName).val(oldColor);
                if (this.model.get('factoryKey') === "page_instance"
                || this.model.get('factoryKey') === "layout_page"
                || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
            }

            },
            redo:() => {
                // Update model
                // PF-4777 Handling for radio and checkbox groups.
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,color,this.model,this.render.bind(this),'CheckboxThemeChange');

                }else{
                    this.model.set(propName, color);
                }

                let newColor = this.resolveColor(propVal);

                // Update text input
                $('#' + propName).val(newColor);
                if (this.model.get('factoryKey') === "page_instance"
                || this.model.get('factoryKey') === "layout_page"
                || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
            }
            }
        },textConstants.UNDO_PROP_CHANGE)
    }

    updateColorAttributesWithValidation(ev){
        const propName = ev.currentTarget.id;
        const propVal = ev.currentTarget.value;
        // this.updateProperty(propName, propVal);
        super.updateColorAttributesWithValidation(ev);
    }

    updateTransparentBackground(ev){
        let name = ev.target.name;
        let value = ev.target.checked;
        let oldPropVal = this.model.get(name);
        if (util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent(name,value,this.model,this.render.bind(this),'GroupPropertyChange')
        }else{
            this.model.set(name, value);
        }

        // if ( this.isThemeProperty(this.model.get('backgroundColor')) ){
        //     themeService.deattachTheme(this);
        // }

        if(util.isTrue(value)){
           $(`input[name=backgroundColor]`).prop('disabled',true);
        }else{
           $(`input[name=backgroundColor]`).prop('disabled',false);
        }

        undoService.add({
            undo: () =>{
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(name,oldPropVal,this.model,this.render.bind(this),'GroupPropertyChange');
                }else{
                    this.model.set(name, oldPropVal);
                }

                if(util.isTrue(value)){
                    $(`input[name=backgroundColor]`).prop('disabled',true);
                }else{
                    $(`input[name=backgroundColor]`).prop('disabled',false);
                }
            },
            redo:() => {
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(name,value,this.model,this.render.bind(this),'GroupPropertyChange');
                }else{
                    this.model.set(name, value);
                }

                if(util.isTrue(value)){
                    $(`input[name=backgroundColor]`).prop('disabled',true);
                }else{
                    $(`input[name=backgroundColor]`).prop('disabled',false);
                }
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

}

export default StyleBackgroundGradientColor;
